export function prop(prop) {
    return function (data) { return data[prop]; };
}
